module.exports = __webpack_public_path__ + "img/a777@2x.f3af0cd9.png";